import { render } from "./IconArrowDown.vue?vue&type=template&id=07793e7b&ts=true"
import script from "./IconArrowDown.vue?vue&type=script&lang=ts"
export * from "./IconArrowDown.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__